<sq-timeline
    [data]="mergedTimeseries$ | async"
    [events]="mergedEvents$ | async"
    [selection]="selection"
    [minDate]="getMinDate()"
    [maxDate]="getMaxDate()"
    [zoomable]="zoomable"
    [minZoomDays]="minZoomDays"
    [maxZoomDays]="maxZoomDays"
    [width]="width"
    [height]="height"
    [margin]="margin"
    [curveType]="curveType"
    [showTooltip]="showTooltip"
    [theme]="theme"

    (selectionChange)="onSelectionChange($event)"
    (rangeInit)="onRangeChange($event)"
    (rangeChange)="onRangeChange($event)">

    <ng-template #tooltipTpl let-event let-close="close">
        <a href="#" (click)="onEventClicked(event, close)"
            class="tooltip-item list-group-item list-group-item-action">
            <span class="small text-muted">{{ event.date | sqDate }}</span>
            <div class="text-truncate">{{ event.display || event.record.title }}</div>
        </a>
    </ng-template>

</sq-timeline>

<sq-timeline-legend *ngIf="showLegend"
    [data]="mergedTimeseries$ | async"
    [events]="legendEvents"
    [legendStyles]="legendStyles"
    [orientation]="legendOrientation"
    [yOffset]="legendYOffset">
</sq-timeline-legend>
